import ShowroomDownloads from "./showroom-downloads";

export default ShowroomDownloads;